<script>

</script>

<div  class="swiper-slide">
  <div class="aspect-[1/1] mb-2 bg-brand-lightgrey">

  </div>
  <p class="h5 mb-1 bg-brand-lightgrey h-2"></p>
  <ul class="flex mb-[13px]">
    <li class="h5 italic bg-brand-lightgrey h-2 w-3 mr-1"></li>
    <li class="h5 italic bg-brand-lightgrey h-2 w-3 mr-1"></li>
    <li class="h5 italic bg-brand-lightgrey h-2 w-3 mr-1"></li>
  </ul>

  <div class="flex mb-[25px] h-2 w-6">

  </div>

  <div class="bg-brand-lightgrey h-2 w-6">

  </div>
</div>
